/*
export default function Authentication() {
    var loginInfo = sessionStorage.getItem('loginInfo');
    console.log(loginInfo)
    if (loginInfo) {
        return true;
    } else {
        return false;
    }
}
*/

const Authentication = () => {
    let data = sessionStorage.getItem('loginInfo');
    let auth = JSON.parse(data);
    if (auth && auth.user)
        return auth;
    else 
        return undefined;
}

export default Authentication;